import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const UndoGlyph = /*#__PURE__*/createElement("g", {
  id: "undo"
}, /*#__PURE__*/createElement("path", {
  d: "M15.2 34.3L25.4 24c.6-.6 1.5-.6 2.1 0 .6.6.6 1.5 0 2.1l-8 8h8.9c37 0 40.9 17.3 40.9 24.7 0 .8-.7 1.5-1.5 1.5s-1.5-.7-1.5-1.5c0-13.8-13.8-21.7-37.9-21.7h-8.8l8 8c.6.6.6 1.5 0 2.1-.6.6-1.5.6-2.1 0L15.2 37c-.8-.7-.8-1.9 0-2.7z"
}));
const Undo = createSvg({
  name: 'undo',
  path: UndoGlyph
});

export default Undo;
export { UndoGlyph };
